import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, MapPin, Users, Calendar, Award, Mail, Phone, Globe, ExternalLink, TrendingUp } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { Avatar, AvatarFallback } from '../components/ui/Avatar';
export function ChapterDetailPage() {
  const navigate = useNavigate();
  const chapter = {
    name: 'Jakarta Tech Community',
    city: 'Jakarta',
    province: 'DKI Jakarta',
    established: '2020',
    members: 245,
    activeMembers: 198,
    events: 48,
    description: 'Chapter Jakarta adalah komunitas teknologi terbesar di Jakarta yang fokus pada pengembangan ekosistem teknologi informasi dan open source. Kami mengadakan berbagai acara seperti workshop, seminar, dan meetup secara rutin.',
    leader: {
      name: 'Budi Santoso',
      position: 'Ketua Chapter',
      email: 'budi@atios.or.id',
      phone: '+62 812 3456 7890'
    },
    contact: {
      email: 'jakarta@atios.or.id',
      phone: '+62 21 1234 5678',
      website: 'https://jakarta.atios.or.id',
      address: 'Jl. Sudirman No. 123, Jakarta Pusat'
    },
    upcomingEvents: [{
      title: 'Workshop React Advanced',
      date: '18 Jan 2025',
      participants: 30
    }, {
      title: 'Meetup Developer Jakarta',
      date: '2 Feb 2025',
      participants: 50
    }],
    recentMembers: [{
      name: 'John Doe',
      role: 'Backend Developer'
    }, {
      name: 'Jane Smith',
      role: 'Frontend Developer'
    }, {
      name: 'Ahmad Wijaya',
      role: 'DevOps Engineer'
    }, {
      name: 'Siti Nurhaliza',
      role: 'UI/UX Designer'
    }]
  };
  const stats = [{
    label: 'Total Anggota',
    value: chapter.members.toString(),
    icon: Users,
    color: 'text-atios-primary',
    bgColor: 'bg-atios-light'
  }, {
    label: 'Anggota Aktif',
    value: chapter.activeMembers.toString(),
    icon: TrendingUp,
    color: 'text-success',
    bgColor: 'bg-success-light'
  }, {
    label: 'Total Acara',
    value: chapter.events.toString(),
    icon: Calendar,
    color: 'text-warning',
    bgColor: 'bg-warning-light'
  }, {
    label: 'Tahun Berdiri',
    value: chapter.established,
    icon: Award,
    color: 'text-neutral-700',
    bgColor: 'bg-neutral-100'
  }];
  return <div className="min-h-screen bg-white" data-id="element-1616">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1617">
        {/* Header */}
        <div className="mb-8" data-id="element-1618">
          <Button variant="ghost" onClick={() => navigate('/chapter')} className="mb-4" data-id="element-1619">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-1620" />
            Kembali ke Daftar Chapter
          </Button>
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-1621">
            <div data-id="element-1622">
              <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-1623">
                {chapter.name}
              </h1>
              <div className="flex items-center gap-2 text-neutral-600" data-id="element-1624">
                <MapPin className="w-4 h-4" data-id="element-1625" />
                <span data-id="element-1626">
                  {chapter.city}, {chapter.province}
                </span>
              </div>
            </div>
            <Button variant="primary" data-id="element-1627">
              <Users className="w-4 h-4 mr-2" data-id="element-1628" />
              Bergabung dengan Chapter
            </Button>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-1629">
          {stats.map((stat, i) => <Card key={i} data-id="element-1630">
              <CardContent className="p-6" data-id="element-1631">
                <div className="flex items-center gap-4" data-id="element-1632">
                  <div className={`p-3 rounded-lg ${stat.bgColor}`} data-id="element-1633">
                    <stat.icon className={`w-6 h-6 ${stat.color}`} data-id="element-1634" />
                  </div>
                  <div data-id="element-1635">
                    <p className="text-2xl font-semibold text-neutral-900" data-id="element-1636">
                      {stat.value}
                    </p>
                    <p className="text-sm text-neutral-600" data-id="element-1637">{stat.label}</p>
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1638">
          {/* Main Content */}
          <div className="lg:col-span-2 space-y-8" data-id="element-1639">
            {/* About */}
            <Card data-id="element-1640">
              <CardHeader data-id="element-1641">
                <CardTitle data-id="element-1642">Tentang Chapter</CardTitle>
              </CardHeader>
              <CardContent data-id="element-1643">
                <p className="text-neutral-700 leading-relaxed" data-id="element-1644">
                  {chapter.description}
                </p>
              </CardContent>
            </Card>

            {/* Upcoming Events */}
            <Card data-id="element-1645">
              <CardHeader data-id="element-1646">
                <CardTitle data-id="element-1647">Acara Mendatang</CardTitle>
              </CardHeader>
              <CardContent data-id="element-1648">
                <div className="space-y-4" data-id="element-1649">
                  {chapter.upcomingEvents.map((event, i) => <div key={i} className="flex items-center justify-between p-4 rounded-lg border border-neutral-200 hover:border-atios-primary transition-colors" data-id="element-1650">
                      <div data-id="element-1651">
                        <h4 className="font-medium text-neutral-900 mb-1" data-id="element-1652">
                          {event.title}
                        </h4>
                        <div className="flex items-center gap-3 text-sm text-neutral-600" data-id="element-1653">
                          <span className="flex items-center gap-1" data-id="element-1654">
                            <Calendar className="w-3.5 h-3.5" data-id="element-1655" />
                            {event.date}
                          </span>
                          <span className="flex items-center gap-1" data-id="element-1656">
                            <Users className="w-3.5 h-3.5" data-id="element-1657" />
                            {event.participants} peserta
                          </span>
                        </div>
                      </div>
                      <Button size="sm" variant="secondary" data-id="element-1658">
                        Detail
                      </Button>
                    </div>)}
                </div>
              </CardContent>
            </Card>

            {/* Recent Members */}
            <Card data-id="element-1659">
              <CardHeader data-id="element-1660">
                <CardTitle data-id="element-1661">Anggota Terbaru</CardTitle>
              </CardHeader>
              <CardContent data-id="element-1662">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-1663">
                  {chapter.recentMembers.map((member, i) => <div key={i} className="flex flex-col items-center p-4 rounded-lg border border-neutral-200 hover:border-atios-primary transition-colors" data-id="element-1664">
                      <Avatar size="md" className="mb-2" data-id="element-1665">
                        <AvatarFallback data-id="element-1666">
                          {member.name.split(' ').map(n => n[0]).join('')}
                        </AvatarFallback>
                      </Avatar>
                      <p className="text-sm font-medium text-neutral-900 text-center" data-id="element-1667">
                        {member.name}
                      </p>
                      <p className="text-xs text-neutral-600 text-center" data-id="element-1668">
                        {member.role}
                      </p>
                    </div>)}
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Sidebar */}
          <div className="space-y-6" data-id="element-1669">
            {/* Leader Info */}
            <Card data-id="element-1670">
              <CardHeader data-id="element-1671">
                <CardTitle className="text-base" data-id="element-1672">Ketua Chapter</CardTitle>
              </CardHeader>
              <CardContent data-id="element-1673">
                <div className="flex items-start gap-3 mb-4" data-id="element-1674">
                  <Avatar size="md" data-id="element-1675">
                    <AvatarFallback data-id="element-1676">
                      {chapter.leader.name.split(' ').map(n => n[0]).join('')}
                    </AvatarFallback>
                  </Avatar>
                  <div data-id="element-1677">
                    <p className="font-semibold text-neutral-900" data-id="element-1678">
                      {chapter.leader.name}
                    </p>
                    <p className="text-sm text-neutral-600" data-id="element-1679">
                      {chapter.leader.position}
                    </p>
                  </div>
                </div>
                <div className="space-y-2 text-sm" data-id="element-1680">
                  <a href={`mailto:${chapter.leader.email}`} className="flex items-center gap-2 text-neutral-600 hover:text-atios-primary transition-colors" data-id="element-1681">
                    <Mail className="w-4 h-4" data-id="element-1682" />
                    <span data-id="element-1683">{chapter.leader.email}</span>
                  </a>
                  <a href={`tel:${chapter.leader.phone}`} className="flex items-center gap-2 text-neutral-600 hover:text-atios-primary transition-colors" data-id="element-1684">
                    <Phone className="w-4 h-4" data-id="element-1685" />
                    <span data-id="element-1686">{chapter.leader.phone}</span>
                  </a>
                </div>
              </CardContent>
            </Card>

            {/* Contact Info */}
            <Card data-id="element-1687">
              <CardHeader data-id="element-1688">
                <CardTitle className="text-base" data-id="element-1689">Kontak Chapter</CardTitle>
              </CardHeader>
              <CardContent className="space-y-3 text-sm" data-id="element-1690">
                <a href={`mailto:${chapter.contact.email}`} className="flex items-center gap-2 text-neutral-600 hover:text-atios-primary transition-colors" data-id="element-1691">
                  <Mail className="w-4 h-4" data-id="element-1692" />
                  <span data-id="element-1693">{chapter.contact.email}</span>
                </a>
                <a href={`tel:${chapter.contact.phone}`} className="flex items-center gap-2 text-neutral-600 hover:text-atios-primary transition-colors" data-id="element-1694">
                  <Phone className="w-4 h-4" data-id="element-1695" />
                  <span data-id="element-1696">{chapter.contact.phone}</span>
                </a>
                <a href={chapter.contact.website} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-neutral-600 hover:text-atios-primary transition-colors" data-id="element-1697">
                  <Globe className="w-4 h-4" data-id="element-1698" />
                  <span data-id="element-1699">Website</span>
                  <ExternalLink className="w-3 h-3 ml-auto" data-id="element-1700" />
                </a>
                <div className="flex items-start gap-2 text-neutral-600 pt-3 border-t border-neutral-200" data-id="element-1701">
                  <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" data-id="element-1702" />
                  <span data-id="element-1703">{chapter.contact.address}</span>
                </div>
              </CardContent>
            </Card>

            {/* CTA */}
            <Card className="bg-gradient-to-br from-atios-light to-white border-atios-primary/20" data-id="element-1704">
              <CardContent className="p-6 text-center" data-id="element-1705">
                <Award className="w-12 h-12 text-atios-primary mx-auto mb-4" data-id="element-1706" />
                <h3 className="font-semibold text-neutral-900 mb-2" data-id="element-1707">
                  Bergabung Sekarang
                </h3>
                <p className="text-sm text-neutral-600 mb-4" data-id="element-1708">
                  Jadilah bagian dari komunitas teknologi terbesar di Jakarta
                </p>
                <Button fullWidth variant="primary" data-id="element-1709">
                  Daftar Chapter
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>;
}